<div class="no-results-wrapper">
  <div class="responsive-flex-wrapper">
    <i class="material-symbols-outlined">{{ icon }}</i>
  </div>
  <span class="no-results-heading">{{ title }}</span>
</div>
